@if (linkedEquipment()) {
  <div class="mb-4 text-sm" role="status">Verknüpfte Komponente
    <a class="ml-2 underline" [routerLink]="[]" [queryParams]="{}">Alle Komponenten anzeigen</a>
  </div>
}
<div class="space-y-6">
  <!-- Inverters Table -->
  <app-data-table
    [data]="visibleEquipment()"
    [columns]="columns"
    [rowActions]="actions"
    [isLoading]="isLoading()"
    [searchableFields]="['name', 'manufacturer', 'power', 'price']"
    addNewLabel="Wechselrichter hinzufügen"
    [showAddButton]="currentOrgStore.can('organization', 'createequipment')"
    emptyStateTitle="Keine Wechselrichter gefunden"
    emptyStateDescription="Fügen Sie Wechselrichter hinzu oder synchronisieren Sie globale Wechselrichter."
    (addNew)="addInverter()"
  />

  <!-- Create Inverter Dialog -->
  <app-create-inverter-dialog
    #createDialog
    [editInverter]="editingInverter()"
    (submitted)="syncInverters()"
  />

  <!-- Templates -->
  <ng-template #inverterTpl let-inverter>
    <div class="text-sm">{{ inverter.name }}</div>
  </ng-template>

  <ng-template #sizeTpl let-inverter>
    <div class="text-right text-sm tabular-nums">{{ inverter.size | number: "1.1-1" }} kW</div>
  </ng-template>

  <ng-template #priceTpl let-inverter>
    <div class="text-right text-sm tabular-nums">{{ inverter.cost | number: "1.2-2" }} €</div>
  </ng-template>
</div>
